import React, { PropsWithChildren, useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { LoadingWrapper } from '@linetweet/linetweet-ui';

import { useAppDispatch, useAppSelector } from '../store/hooks';
import { getCurrentUser, getUserSettings } from 'store/user/thunk';
import { selectCurrentUserLoading } from 'store/user/selectors';

export function AuthWrapper(props: PropsWithChildren) {
  const dispatch = useAppDispatch();
  
  const currentUser = useAppSelector((state: any) => state.user);
  const currentUserLoading = useAppSelector(selectCurrentUserLoading, shallowEqual);

  useEffect(() => {
    dispatch(getCurrentUser());
    dispatch(getUserSettings());
  }, [dispatch]);

  if (currentUserLoading) {
    return <LoadingWrapper loading={true} />;
  }

  if (!currentUser || currentUser.currentUser === undefined) {
    return <div>Access forbidden</div>;
  }

  return (
    <>{props.children}</>
  );
}
